import { ReactFlowJsonObject } from "reactflow";
import { Country } from "./Country";
import api from "./api";

export type Tool = {
    _id?: string;
    title: string;
    color: string;
    country: Country | string;
}    

const URL = 'tools/'
export const ToolService = {

    create: function (tool: Tool) {
        return api.post(URL, tool);
    },
    update: function (tool: Tool) {
        return api.patch(URL + tool._id + '/', tool)
    },
    delete: function (toolId: string) {
        return api.delete(URL + toolId + '/')
    },
    getById: function (toolId: string) {
        return api.get(URL + toolId + '/')
    },
    getAll: function (country?: string) {
        return api.get(URL + 'all/?country=' + country)
    }
}
